<script setup>
import { computed } from 'vue'

const props = defineProps({
    money: Object,
    showFree: Boolean
})

const formattedMoney = computed(() => {
    const amount = parseInt(props.money.amount)
    const currency = props.money.currency || 'EUR'

    if (amount === 0 && props.showFree) {
        return 'GRATIS'
    }

    const price = new Intl.NumberFormat('nl-NL', {
        currency: currency,
        style: 'currency',
    }).format(amount / 100)

    return price.replace(',00', ',-')
})
</script>

<template>
    <span v-html="formattedMoney"></span>
</template>
